var _circle, _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDepT(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 576,
    height: 576,
    viewBox: "0 0 576 576",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 287.88,
    cy: 287.88,
    r: 287.88,
    fill: "none"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_998_619",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 142,
    y: 190,
    width: 318,
    height: 318
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 142.604,
    y: 190.14,
    width: 316.9,
    height: 316.9,
    fill: "url(#pattern0_998_619)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_998_619)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -293.133,
    y: -15.845,
    width: 1117.07,
    height: 768.483,
    fill: "#FA0073"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_998_619",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_998_619",
    transform: "scale(0.015625)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_998_619",
    width: 64,
    height: 64,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepT);
export default __webpack_public_path__ + "static/media/depT.5d607a37e183ef8cdd56d8e6e059d45c.svg";
export { ForwardRef as ReactComponent };